import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-musicblock',
  templateUrl: './musicblock.component.html',
  styleUrls: ['./musicblock.component.scss']
})
export class MusicblockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
